module.exports = __webpack_public_path__ + "e1841b20d7cf33d0fc786a07e61892f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-12.png
// module id = 2310
// module chunks = 0